import { Injectable } from '@angular/core';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { ManPowerDto } from '../models/ManPowerDto';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { startAdvertVM } from '../models/startAdvertVM';
import { CloseRecruitmentVM } from '../models/CloseRecruitmentVM';
import { OnboardNewHireVM } from '../models/requests/OnboardNewHireVM';
import { DocumentUploadDto } from '../models/requests/DocumentUploadDto';

@Injectable({
  providedIn: 'root'
})
export class ManpowerrecruitmentService {

  constructor(private httpClient: HttpClient) { }

  
  RequestByStatus(obj: any): Observable<ApiResponseObject<ManPowerDto[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<ManPowerDto[]>>(`${environment.apiUrl}/RecruitmentManager/RequestByStatus`, obj);
  }

    
  startAdvert(model: startAdvertVM): Observable<ApiResponseObject<boolean[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<boolean[]>>(`${environment.apiUrl}/RecruitmentManager/StartAdvert`, model);
  }
  
  EndAdvert(model: startAdvertVM): Observable<ApiResponseObject<boolean[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<boolean[]>>(`${environment.apiUrl}/RecruitmentManager/EndAdvert`, model);
  }
  
  StartShortlisting(model: startAdvertVM): Observable<ApiResponseObject<boolean[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<boolean[]>>(`${environment.apiUrl}/RecruitmentManager/StartShortlisting`, model);
  }
  
  ShortListing(model: startAdvertVM): Observable<ApiResponseObject<boolean[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<boolean[]>>(`${environment.apiUrl}/RecruitmentManager/ShortListing`, model);
  }
  
  StartInterview(model: startAdvertVM): Observable<ApiResponseObject<boolean[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<boolean[]>>(`${environment.apiUrl}/RecruitmentManager/StartInterview`, model);
  }
  
  StopInterview(model: startAdvertVM): Observable<ApiResponseObject<boolean[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<boolean[]>>(`${environment.apiUrl}/RecruitmentManager/StopInterview`, model);
  }
  
  StartOfferProcess(model: startAdvertVM): Observable<ApiResponseObject<boolean[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<boolean[]>>(`${environment.apiUrl}/RecruitmentManager/StartOfferProcess`, model);
  }
  
  EndOfferProcess(model: startAdvertVM): Observable<ApiResponseObject<boolean[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<boolean[]>>(`${environment.apiUrl}/RecruitmentManager/EndOfferProcess`, model);
  }
  
  PutonHold(model: startAdvertVM): Observable<ApiResponseObject<boolean[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<boolean[]>>(`${environment.apiUrl}/RecruitmentManager/PutonHold`, model);
  }
  AcceptOffer(model: startAdvertVM): Observable<ApiResponseObject<boolean[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<boolean[]>>(`${environment.apiUrl}/RecruitmentManager/AcceptOffer`, model);
  }
  
  
  CloseRecruitment(model: CloseRecruitmentVM): Observable<ApiResponseObject<boolean[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<boolean[]>>(`${environment.apiUrl}/RecruitmentManager/CloseRecruitment`, model);
  }
  
  GetByVacancyStatus(obj: any): Observable<ApiResponseObject<ManPowerDto[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<ManPowerDto[]>>(`${environment.apiUrl}/RecruitmentManager/ByVacancyStatus`, obj);
  }

  
  GetRecruitmentByLocation(obj: any): Observable<ApiResponseObject<ManPowerDto[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<ManPowerDto[]>>(`${environment.apiUrl}/RecruitmentManager/RecruitmentByLocation`, obj);
  }

  
  RecruitmentByFunction(obj: any): Observable<ApiResponseObject<ManPowerDto[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<ManPowerDto[]>>(`${environment.apiUrl}/RecruitmentManager/RecruitmentByFunction`, obj);
  }

  
  CompleteToolRequest(model: object): Observable<ApiResponseObject<boolean>> {
    ;
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/RecruitmentManager/CompleteToolRequest`, model);
  }



onboardNewHire(model: OnboardNewHireVM): Observable<ApiResponseObject<any>> {
  ;
  return this.httpClient.post<ApiResponseObject<any>>(
    `${environment.apiUrl}/RecruitmentManager/OnboardNewHire`,
    model
  );
}
newHires(): Observable<ApiResponseObject<any>> {
  
  return this.httpClient.get<ApiResponseObject<any>>(
    `${environment.apiUrl}/RecruitmentManager/GetAllNewHireExternal`
  );
}

//not in use for now 
NewHireSubmitResponse(request: DocumentUploadDto): Observable<ApiResponseObject<any>> {
  

  var ret =
   this.httpClient.post<ApiResponseObject<any>>(
    `${environment.apiUrl}/RecruitmentManager/NewHireResponse`,
    request 
  );
  return ret;
}


}

